import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"Qgwun","textWrapNowrap":"zmCHe","alignRight":"UUeOV","alignCenter":"aDqsX","sizeFullWidth":"mBwxP","renderedInTable":"_2xkAj","sizeOriginal":"_4ntW9","sizeContent":"mUlT2","sizeSmall":"wxbv4","sizeSmallCenter":"_4unLh","flex":"hjiv0","atomic":"_7yl1n","anchor":"J9YXq","embed":"_6NxN6","horizontalScrollbar":"ztqGs","pluginContainerMobile":"MyV-n"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-6aa61226.js.map
